import React, { useEffect } from 'react';
import Typography from '@material-ui/core/Typography';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import flagEN from '../../locales/flags/gb.png';
import flagFI from '../../locales/flags/fin.png';
import flagSWE from '../../locales/flags/se.png';
import i18n from '../../i18n';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { setPreferredLanguage } from '../../actions/doris';
import { makeStyles } from '@material-ui/core/styles';



const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    flexWrap: 'nowrap',
    paddingRight: theme.spacing(1),
  },
  rowContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    alignItems: 'center'
  },
  menuLabel: {
    'marginLeft': theme.spacing(1)
  },
  select: {
    '& .MuiInputBase-input': {
      padding: 0,
      paddingRight: theme.spacing(3)
    },
    '&.MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottom: 0,
    },
    '&:active': {
      backgroundColor: 'none'
    },
    '&:before': {
      borderBottom: 0
    },
    '&:hover': {
      borderBottom: 0
    },
    '&:after': {
      borderBottom: 0
    },
  },
}));

const LangMenu = () => {
  const preferredLanguage = useSelector(state => state.doris.preferredLanguage);
  const classes = useStyles();
  const { t } = useTranslation(); // eslint-disable-line no-unused-vars
  const dispatch = useDispatch();


  const handleChange = (event) => {
    setPreferredLanguage(dispatch, event.target.value);
  };

  const changeLanguage = (ln) => {
    return () => {
      i18n.changeLanguage(ln);
    };
  };

  useEffect(() => {
    i18n.changeLanguage(preferredLanguage);
  }, [preferredLanguage]);

  return (

    <div className={classes.root}>
      <Select
        className={classes.select}
        value={preferredLanguage}
        onChange={handleChange}>
        <MenuItem
          onClick={changeLanguage('fi')}
          value={'fi'}>
          <div className={classes.rowContainer}>
            <img src={flagFI} height="20px" width="30px" />
            <Typography className={classes.menuLabel}> Suomi</Typography>
          </div>
        </MenuItem>
        <MenuItem
          onClick={changeLanguage('en')}
          value={'en'}>
          <div className={classes.rowContainer}>
            <img src={flagEN} height="20px" width="30px" />
            <Typography className={classes.menuLabel}> English</Typography>
          </div>
        </MenuItem>
        <MenuItem
          onClick={changeLanguage('se')}
          value={'se'}>
          <div className={classes.rowContainer}>
            <img src={flagSWE} height="20px" width="30px" />
            <Typography className={classes.menuLabel}> Svenska</Typography>
          </div>
        </MenuItem>
      </Select>
    </div>
  );
};


export default LangMenu;
